<script lang="ts">
    import { slide, fade, fly } from "svelte/transition";
    export let message:string = 'Notification';
</script>

<div transition:fly={{y:-16}}>
    <p>{message}</p>
</div>

<style>
    div {
        background-color: var(--background);
        border: 1px solid var(--background-offset);
        border-radius: 4px;
        padding: 1rem;
        width: 300px;
        margin-bottom: 1rem;
    }
    p {
        margin: 0;
    }
</style>